import React from "react";
import * as LucideIcons from "lucide-react";
import { PROCESS } from "../../data/business";

function stepIcon(name) {
  return LucideIcons[name] || LucideIcons.Wrench;
}

function DesktopStep({ step, isLast }) {
  const Icon = stepIcon(step.icon);
  return (
    <div className="relative flex flex-col items-center text-center" data-testid={`process-step-${step.step}`}>
      {/* Connector line — drawn to the next node, not on the last */}
      {!isLast && <div className="absolute top-12 left-[60%] right-[-40%] h-0.5 abc-flow-line" aria-hidden="true" />}
      <div className="relative z-10">
        <div className="w-24 h-24 rounded-full bg-white text-[#1A1D21] flex items-center justify-center shadow-[0_20px_40px_rgba(84,97,110,0.25)] ring-4 ring-white/10">
          <Icon className="w-10 h-10" strokeWidth={1.7} />
        </div>
        <div className="absolute -top-2 -right-2 w-9 h-9 rounded-full bg-[#E31D2B] text-[#1A1D21] font-display font-extrabold flex items-center justify-center shadow-md">
          {step.step}
        </div>
      </div>
      <h3 className="font-display font-bold text-lg mt-6">{step.title}</h3>
      <p className="text-sm text-white/70 mt-2 leading-relaxed max-w-[220px]">{step.desc}</p>
    </div>
  );
}

function MobileStep({ step, isLast }) {
  const Icon = stepIcon(step.icon);
  return (
    <div className="relative flex gap-5" data-testid={`process-step-mobile-${step.step}`}>
      {!isLast && <div className="absolute top-20 left-[39px] bottom-[-32px] w-0.5 abc-flow-line-v" aria-hidden="true" />}
      <div className="relative flex-shrink-0">
        <div className="w-20 h-20 rounded-full bg-white text-[#1A1D21] flex items-center justify-center shadow-[0_12px_30px_rgba(84,97,110,0.25)] ring-4 ring-white/10">
          <Icon className="w-8 h-8" strokeWidth={1.7} />
        </div>
        <div className="absolute -top-1.5 -right-1.5 w-8 h-8 rounded-full bg-[#E31D2B] text-[#1A1D21] font-display font-extrabold flex items-center justify-center text-sm shadow-md">
          {step.step}
        </div>
      </div>
      <div className="pt-2">
        <h3 className="font-display font-bold text-lg">{step.title}</h3>
        <p className="text-sm text-white/70 mt-1.5 leading-relaxed">{step.desc}</p>
      </div>
    </div>
  );
}

export default function ProcessSection() {
  return (
    <section className="py-16 md:py-24 bg-[#1A1D21] text-white relative overflow-hidden" data-testid="home-process">
      <div className="absolute inset-0 abc-grid-pattern opacity-40 pointer-events-none" />
      <div className="abc-container relative">
        <div className="max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-widest text-[#E31D2B] mb-3">Our process</div>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold">Simple, honest, fast.</h2>
          <p className="mt-3 text-white/70 max-w-lg">Four clear steps from your first call to a clean job site — no surprises in between.</p>
        </div>

        {/* Desktop roadmap */}
        <div className="hidden md:block mt-16 relative">
          <div className="grid grid-cols-4 gap-6 relative">
            {PROCESS.map((p, idx) => (
              <DesktopStep key={p.step} step={p} isLast={idx === PROCESS.length - 1} />
            ))}
          </div>
        </div>

        {/* Mobile roadmap (vertical) */}
        <div className="md:hidden mt-12 relative">
          <div className="space-y-8 relative">
            {PROCESS.map((p, idx) => (
              <MobileStep key={p.step} step={p} isLast={idx === PROCESS.length - 1} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
